import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Sift from "@/components/sift/Sift";
import { getNoticeList, handleNoticeDelete } from "@/api/managementCenter/notification";
import { getSupList, setSupStatus } from "@/api/overseasChinese/overseasChinese";
export default {
  name: "SupplementaryApproval",
  components: {
    Sift: Sift
  },
  props: [],
  data: function data() {
    return {
      loading: false,
      siftData: [{
        type: "text",
        key: "className",
        label: "班级名称",
        placeholder: "请输入班级名称",
        default: ""
      }, {
        type: "text",
        key: "name",
        label: "姓名",
        placeholder: "请输入姓名",
        default: ""
      }],
      list: [],
      pageSizes: [10, 20, 30, 50, 100],
      paramSearch: {
        current: 1,
        size: 10,
        name: "",
        className: ""
      },
      total: 0,
      selectList: []
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this.getListFn();
  },
  methods: {
    setStatus: function setStatus(status) {
      var _this = this;

      var params = {
        idList: this.selectList || [],
        type: status
      };
      setSupStatus(params).then(function (res) {
        if (res.data.code == "0") {
          _this.$message.success("操作成功!");

          _this.getListFn();
        } else {
          _this.$message.warning(res.data.msg || "操作失败!");
        }
      }).catch(function () {
        _this.$message.error("服务异常");
      });
    },
    // 获取查询列表
    getListFn: function getListFn() {
      var _this2 = this;

      this.loading = true;
      getSupList(this.paramSearch).then(function (res) {
        _this2.loading = false;

        if (res.data.code == 0) {
          _this2.list = res.data.data.records || [];
          _this2.total = res.data.data.total;
        }
      }).catch(function () {
        _this2.loading = false;
      });
    },
    // 默认页面数据
    initPage: function initPage() {
      this.paramSearch = _objectSpread(_objectSpread(_objectSpread({}, this.paramSearch), this.$refs.needSift.getValue()), {}, {
        current: 1
      });
      this.getListFn();
    },
    // 条数
    changeSize: function changeSize(value) {
      this.paramSearch.size = value;
      this.paramSearch.current = 1;
      this.getListFn();
    },
    // 翻页
    changePage: function changePage(value) {
      this.paramSearch.current = value;
      this.getListFn();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.selectList = val.map(function (item) {
        return item.id;
      });
    }
  },
  watch: {},
  filters: {}
};